import React from 'react';
import { graphql, withPrefix } from 'gatsby';
import Feed from '../components/Feed';
import Page from '../components/Page';
import { strings } from '../utils/localization';

const CategoryTemplate = ({ data, pageContext }) => {
    const {
        title: siteTitle,
        subtitle: siteSubtitle
    } = data.site.siteMetadata;

    const { tag, slugsHref } = pageContext;
    const { edges } = data.allMdx;
    const pageTitle = `${strings.category} ${tag} - ${siteTitle}`;

    return (
        <Page pageTitle={pageTitle} description={siteSubtitle} fullWidth={true}>
            <Feed title={`${strings.category} ${tag}`} edges={edges} slugsHref={withPrefix(slugsHref)}/>
        </Page>
    );
};

export const query = graphql`
query CategoryTemplate($tag: String) {
    site {
        siteMetadata {
            title
            subtitle
        }
    }
    allMdx(filter: { frontmatter: { tags: { in: [$tag] }, author: { ne: null } } }, limit: 3) {
        ...Edges
    }
}
`;

export default CategoryTemplate;
